import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { Divider } from 'semantic-ui-react';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import { RouterProps } from 'react-router';
import { OpenItemListData, OpenItemListSearchResponse } from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';
import { BillJournalOrderBy } from 'ts-types/api.enums';
import moment from 'moment';
import styled from 'styled-components';
import OpenItemListOptionsSegment from 'components/billing/open-item-list/segments/OpenItemListOptionsSegment';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import OpenItemListTableSegment from 'components/billing/open-item-list/segments/OpenItemListTableSegment';
import _ from 'lodash';
import { SortDirection, SortDirectionType, TableProps } from 'react-virtualized';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export interface OpenItemListFormData {
  bills: Array<OpenItemListSearchResponse>,
  mandateId: number,
  date: string,
  patientId?: number,
  orderBy: BillJournalOrderBy
}

interface Props extends AuthConsumerRenderProps, PatientConsumerRenderProps, MessageSourceProps, RouterProps {
}

interface State {
  openItemListData: OpenItemListData,
  billsLoading: boolean,
  formData: OpenItemListFormData,
  sortDirection: SortDirectionType,
  sortBy: string,
  errorMessage?: string,
  cancelTokenSource: CancelTokenSource
}

class OpenItemListView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      openItemListData: this.initialOpenItemListDataValues(),
      billsLoading: false,
      formData: this.initialOutputFormValues(),
      sortBy: BillJournalOrderBy.BILL_NUMBER,
      sortDirection: SortDirection.DESC,
      cancelTokenSource: cancelTokenSource
    };

  }

  initialOutputFormValues = (): OpenItemListFormData => {

    const {currentUser, currentPatient} = this.props;

    const date = moment().endOf('month').format("YYYY-MM-DD");

    return {
      mandateId: currentUser ? currentUser.userConfig.mandateId : 1,
      date: date,
      patientId: currentPatient ? currentPatient.id : undefined,
      orderBy: BillJournalOrderBy.BILL_NUMBER,
      bills: []
    }
  };

  initialOpenItemListDataValues = (): OpenItemListData => {
    return {
      bills: [],
      totalAmount: 0,
      totalPaidAmount: 0,
      totalOpenAmount: 0
    }
  };

  _sortList = (sortBy: string, sortDirection: SortDirectionType, bills: OpenItemListSearchResponse[]): OpenItemListSearchResponse[] => {
    let newList: OpenItemListSearchResponse[] = _.sortBy(bills, sortBy);
    if (sortDirection === SortDirection.DESC) {
      newList.reverse();
    }
    return newList;
  };

  _sort = ({sortBy, sortDirection}: any) => {
    const {openItemListData, formData} = this.state;
    this.setState({
      sortBy,
      sortDirection,
      openItemListData: {
        ...openItemListData,
        bills: this._sortList(sortBy, sortDirection, openItemListData.bills)
      },
      formData: {
        ...formData,
        bills: this._sortList(sortBy, sortDirection, formData.bills)
      }
    });
  };

  setOutputFormData = (outputFormData: OpenItemListFormData): void => {
    this.setState({
      formData: outputFormData
    });
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    });
  };

  onFilterOpenItemListData = (openItemListData: OpenItemListData) => {
    this.setState({
      openItemListData: openItemListData
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  render(): React.ReactElement {

    const {currentPatient} = this.props;

    const {
      openItemListData,
      billsLoading,
      formData,
      sortBy,
      sortDirection,
      errorMessage
    } = this.state;

    const patientId = currentPatient ? currentPatient.id : undefined;

    return (
        <PraxStyledSegment>
          <StyledContainer>
            {errorMessage
            && (
                <StyledErrorMessage onDismiss={() => this.setErrorMessage()} style={{margin: 0}}>
                  {errorMessage}
                </StyledErrorMessage>
            )
            }
            <OpenItemListOptionsSegment
                bills={openItemListData.bills}
                patientId={patientId}
                onFilterOpenItemListData={this.onFilterOpenItemListData}
                onBillsLoadingChange={this.onBillsLoadingChange}
                setOutputFormData={this.setOutputFormData}
                setErrorMessage={this.setErrorMessage}
            />
            <Divider/>
            <OpenItemListTableSegment
                openItemListData={openItemListData}
                billsLoading={billsLoading}
                formData={formData}
                sortBy={sortBy}
                sortDirection={sortDirection}
                sort={this._sort}
                setErrorMessage={this.setErrorMessage}
            />
          </StyledContainer>
        </PraxStyledSegment>
    );
  }

}

export default withAuthContext(withPatientContext(withMessages(OpenItemListView)));
